<template>
  <div class="return-list" ref="container">
    <div class="goodWrapper" v-for="order in orderList" :key="order.order_id">
      <!-- <div class="orderNum">订单号：{{ order.order_id }}</div> -->
      <div class="orderNum">售后编号：{{ order.refunds_sn }}</div>
      <div class="item acea-row row-between-wrapper">
        <div class="pictrue">
          <img
            :src="order.goods_info.image"
            class="image"
            @click.stop="$router.push({ path: '/detail/' + order.goods_info.product_id })"
          />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1">{{ order.goods_info.store_name }}</div>
            <!-- <div class="num">x {{ order.cart_num }}</div> -->
          </div>
          <div class="attr line1">
            {{ order.goods_info.suk }}
          </div>
		  <div class="attr line1" v-if="order.goods_info.spec_type == 1">
		    {{ order.goods_info.spec_values }}
		  </div>
          <!-- <div class="money">￥{{ order.goods_info.price }}</div> -->
        </div>
	  </div>
	  <div class="refund-status">
		  <span v-if="order.refunds_type == 1 || order.refunds_type == 2" class="refund-status-span-yellow">退</span>
		  <span v-if="order.refunds_type == 3" class="refund-status-span-yellow">换</span>
		  <span class="refund-status-span-gray">{{ order.refunds_type_text }}</span>
		  {{ order.status_info }}
	  </div>
      <div class="totalSum">
        <span @click="$router.push(order.jump_url)">查看详情</span>
      </div>
    </div>
    <div class="noCart" v-if="orderList.length === 0 && page > 1">
      <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>

<script>
import { RefundList } from "@api/order";
import Loading from "@components/Loading";

export default {
  name: "ReturnList",
  components: {
    Loading
  },
  data() {
    return {
      orderList: [],
      page: 1,
      limit: 20,
      loading: false,
      loaded: false
    };
  },
  mounted() {
    this.getOrderList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getOrderList();
    });
  },
  methods: {
    getOrderList() {
      const { page, limit } = this;
      if (this.loading || this.loaded) return;
      this.loading = true;
      RefundList(page,limit).then(res => {
        this.orderList = this.orderList.concat(res.data);
        this.loading = false;
        this.loaded = res.data.length < limit;
        this.page++;
      });
    }
  },
  
};
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
.totalSum span{padding: 0.1rem 0.2rem;border: 1px solid #ccc;border-radius: 3px;}
.refund-status{padding: 0.2rem 0.3rem;}
.refund-status-span-yellow{color: #f3c46c;display: inline-block;border-radius: 50%;border: 1px solid #f3c46c;width: 0.4rem;height: 0.4rem;text-align: center;line-height: 0.35rem;font-size: 0.24rem;margin-right: 0.1rem;}
.refund-status-span-gray{color: #999;}
.return-list .goodWrapper .orderNum{border-bottom: none;font-size: 0.28rem;}
.return-list .goodWrapper .item{background-color: #fafafa;margin-left: 0;padding-left: 0.3rem;}
@media screen and (min-width:960px){
	.noCart {
	  margin-top: 0.08rem;
	  padding-top: 0.05rem;
	}
	.noCart .pictrue {
	  width: 2rem;
	  height: 1.5rem;
	  margin: 0.35rem auto 0.25rem auto;
	}
	.totalSum span{padding: 0.05rem 0.1rem;}
	.refund-status{padding: 0.1rem 0.15rem;}
	.refund-status-span-yellow{width: 0.2rem;height: 0.2rem;line-height: 0.17rem;font-size: 0.12rem;margin-right: 0.05rem;}
	.return-list .goodWrapper .orderNum{font-size: 0.14rem;}
	.return-list .goodWrapper .item{padding-left: 0.15rem;}
}
</style>
